import { Splide } from "@splidejs/splide";
import { UpdateSplideArrows } from '../splideExtensions/updateSplideArrows';
import { SetBackgroundColorAfterBefore } from "../splideExtensions/setBackgroundColorAfterBefore";

const articleSlider = {
    init() {
        const sliderElements = document.getElementsByClassName('article-slider');

        for (let sliderElement of sliderElements) {
            const activeMobile = sliderElement.getAttribute('data-slider-mobile-active') === 'true';
            const activeDesktop = sliderElement.getAttribute('data-slider-desktop-active') === 'true';
            const sliderEntriesPerPage = sliderElement.hasAttribute('data-slider-entries-per-page') ? parseInt(sliderElement.getAttribute('data-slider-entries-per-page')) : 2;
            const arrowPath = 'M26.0298 19.4703C26.3204 19.7609 26.3204 20.239 26.0298 20.5297L17.0298 29.5297C16.7392 29.8203 16.261 29.8203 15.9704 29.5297C15.6798 29.239 15.6798 28.7609 15.9704 28.4703L24.4407 20L15.9704 11.5297C15.6798 11.239 15.6798 10.7609 15.9704 10.4703C16.261 10.1797 16.7392 10.1797 17.0298 10.4703L26.0298 19.4703Z';

            var slider = new Splide(sliderElement, {
                type: 'loop',
                padding: '10%',
                perPage: sliderEntriesPerPage,
                arrows: true,
                gap: '1.5rem',
                omitEnd: true,
                destroy: !activeDesktop,
                pagination: true,
                arrowPath: arrowPath,
                breakpoints: {
                    1024: {
                        perPage: 2,
                        gap: '1rem',
                        destroy: !activeMobile,
                    },
                    768: {
                        perPage: 1,
                        gap: '0.75rem',
                    },
                    480: {
                        perPage: 1,
                        gap: '0.25rem',
                    },
                },
            });
            slider.mount({ UpdateSplideArrows, SetBackgroundColorAfterBefore });
        }
    },
};

export { articleSlider as default };
